module.exports = __webpack_public_path__ + "img/practicas.bf84c758.png";